export default {
    error: 'x-1',
    warning: 'info-1',
    caution: 'info-1',
    success: 'tick-1',
};



// WEBPACK FOOTER //
// ./~/@99designs/asimov/platform-settings/settings/semantic-icons.js